<template>
    <div :class="{ 'is-active' : active, 'is-closing' : closing  }"  @click.self="close">
            <slot></slot>
    </div>
</template>
<script>
    export default {
        props: ['name'],
        data() {
            return {
                active: false,
                closing: true,
                items: this.menus
            }
        },
        mounted() {
            window.Event.$on('topnav.open', (name) => {
                if(name === this.name){
                   this.toggleMenu();
                }
            });
        },
        methods: {
            close() {
                this.closing = true;

                setTimeout(() => {
                    this.active = false;
                }, 300);
            },
            open() {
                this.closing = false;
                this.active = true;
            },
            toggleMenu(){
                this.active = !this.active;
            },
            openClass(menu){
                return {
                    'is-open' : menu.active
                }
            }
        },
    }
</script>
